<template>
  <div class="video-player">
    <div class="video-player--close" @click="close">
      <fa class="icon-close" :icon="['fas', 'times']" />
    </div>
    <div class="video-player--container">
      <div class="video-player--wrapper">
        <transition name="fast-fade">
          <video :key="source" :src="$store.state.assetsPath + source" autoplay muted playsinline type="video/mp4" @ended="close"></video>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'video-player',

  props: ['source'],

  methods: {

    close () {
      this.$emit('close')
    },
  }
}
</script>

<style lang="scss" scoped>
.video-player {
  background: rgba(#000, .8);
  bottom: 23.25rem;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 100;

  &--close {
    align-items: center;
    bottom: 0;
    display: flex;
    height: 5rem;
    justify-content: center;
    position: absolute;
    right: 0;
    width: 5rem;
    z-index: 10;

    .icon-close {
      font-size: 4rem;
    }
  }

  &--container {
    height: 100%;
    padding: 5rem;
    position: relative;
    width: 100%;
  }

  &--wrapper {
    border-radius: .5rem;
    overflow: hidden;
    position: absolute;
    top: 5rem;
    right: 5rem;
    bottom: 5rem;
    left: 5rem;

    video {
      position: absolute;
      object-fit: cover;
      height: 100%;
      width: 100%;
    }
  }
}
</style>